import styled from "styled-components"

import { ActionAnchor, ActionLink, DashboardGrid, Panel, PanelEyebrow, PanelText, PanelTitle } from "@features/portal/PortalPrimitives"
import InstallPortalButton from "@features/pwa/InstallPortalButton"
import PortalShell from "../Common/PortalShell"

const Steps = styled.ol`
  margin: 1.2rem 0 0;
  padding: 0;
  list-style: none;
  counter-reset: step;

  li {
    position: relative;
    min-height: 54px;
    padding: 0.85rem 0 0.85rem 3rem;
    border-top: 1px solid #d3dce4;
    color: #405a70;
    line-height: 1.55;
    counter-increment: step;
  }

  li::before {
    content: counter(step, decimal-leading-zero);
    position: absolute;
    top: 0.85rem;
    left: 0;
    color: #337abd;
    font-size: 0.78rem;
    font-weight: 850;
    letter-spacing: 0.08em;
  }
`

const InstallArea = styled.div`
  margin-top: 1.35rem;

  button {
    min-height: 48px;
    padding: 0 1.2rem;
    background: #55aee0;
    border-color: #55aee0;
    color: #071a2e;
  }
`

const Help = () => (
  <PortalShell title="Aide et contact" eyebrow="Un chemin simple">
    <DashboardGrid>
      <Panel $span={7} $dark>
        <PanelEyebrow>Urgence locataire · 7 j/7</PanelEyebrow>
        <PanelTitle>Quand la situation ne peut pas attendre.</PanelTitle>
        <PanelText>
          Pour un dégât d’eau actif, un risque électrique, une absence de chauffage en période froide ou toute situation dangereuse, appelez
          directement. Une demande dans l’espace ne remplace pas cet appel.
        </PanelText>
        <ActionAnchor href="tel:+14186849004">Appeler le (418) 684-9004</ActionAnchor>
      </Panel>

      <Panel $span={5}>
        <PanelEyebrow>Demande non urgente</PanelEyebrow>
        <PanelTitle>Gardez le suivi au même endroit.</PanelTitle>
        <PanelText>
          Créez un dossier pour joindre des photos, préciser vos disponibilités et échanger avec l’équipe dans le fil de la demande.
        </PanelText>
        <ActionLink to="/app/nouvelle-demande">Créer une demande</ActionLink>
      </Panel>

      <Panel $span={6}>
        <PanelEyebrow>Fonctionnement</PanelEyebrow>
        <PanelTitle>Trois étapes, puis un suivi clair.</PanelTitle>
        <Steps>
          <li>Choisissez le type de demande et indiquez l’adresse concernée.</li>
          <li>Décrivez la situation et ajoutez jusqu’à trois photos utiles.</li>
          <li>Consultez le statut et répondez aux messages de l’équipe dans le dossier.</li>
        </Steps>
      </Panel>

      <Panel $span={6} $dark>
        <PanelEyebrow>Accès rapide</PanelEyebrow>
        <PanelTitle>Ajoutez Espace TB à votre écran d’accueil.</PanelTitle>
        <PanelText>
          L’installation est facultative. Le même espace continue de fonctionner directement dans votre navigateur, sur ordinateur comme sur
          téléphone.
        </PanelText>
        <InstallArea>
          <InstallPortalButton label="Installer Espace TB" />
        </InstallArea>
      </Panel>

      <Panel $span={12}>
        <PanelEyebrow>Autre question</PanelEyebrow>
        <PanelTitle>Écrivez à l’équipe.</PanelTitle>
        <PanelText>Pour un problème de connexion ou une question qui ne concerne pas une intervention, utilisez l’adresse générale.</PanelText>
        <ActionAnchor href="mailto:info@tbgestionimmobiliere.com">info@tbgestionimmobiliere.com</ActionAnchor>
      </Panel>
    </DashboardGrid>
  </PortalShell>
)

export default Help
